import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./PersonDocuments.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Document from "./Document";
import Dropdown from "react-bootstrap/Dropdown";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function PersonDocuments({ id, documents, handleDownloadDocument }) {
  const { t } = useTranslation();

  return (
    <Col className="mt-3 ">
      <Col>
        <Row className="align-items-center">
          <Col className="right people-content mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/people/document/new/${id}`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Personas.Persona.Documentos.SubirDocumento")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Col>
      <Col className="person-documents">
        {documents.length > 0 ? (
          documents.map((item) => (
            <Document
              key={item._id}
              id={item._id}
              user={id}
              title={item.name}
              downloadUrl={item.downloadUrl}
              handleDownloadDocument={handleDownloadDocument}
            />
          ))
        ) : (
          <Col className="empty-documents center">
            <h5>{t("Personas.Persona.Documentos.SinDocumentos")}</h5>
          </Col>
        )}
      </Col>
    </Col>
  );
}

export default PersonDocuments;
